<template>
  <WizardPage
    v-if="shouldRender"
    title="Datenschutzbestimmungen"
    can-navigate-back
    :can-navigate-forward="hasAcceptedDSB"
    :step="step">
    <InputDSB
      label="Ich akzeptiere die Datenschutzbestimmungen."
      v-model="hasAcceptedDSB" />
  </WizardPage>
</template>

<script>
import WizardPage from './WizardPage'
import WizardPageMixin from './../mixins/WizardPageMixin'
import InputDSB from '@/components/inputs/InputDSB'

export default {
  name: 'WizardPageDSB',

  components: {
    WizardPage,
    InputDSB
  },

  mixins: [
    WizardPageMixin
  ],

  data () {
    return {
      hasAcceptedDSB: false
    }
  }
}
</script>
